import React, { useState } from "react"
import type { GradingCriterion } from "../../../proto/qf/types_pb"
import { GradingCriterion_Grade } from "../../../proto/qf/types_pb"
import { useAppState } from "../../overmind"
import UnstyledButton from "../UnstyledButton"
import CriterionComment from "./Comment"
import CriteriaStatus from "./CriteriaStatus"
import GradeComment from "./GradeComment"


/* Criteria component for the manual grading page */
const Criteria = ({ criteria }: { criteria: GradingCriterion }) => {

    // editing, setEditing is used to toggle the GradeComment component
    const [editing, setEditing] = useState<boolean>(false)
    const [showComment, setShowComment] = useState<boolean>(true)
    const { isTeacher } = useAppState()

    // classname is used to style the first column of the row returned by this component
    // it adds a vertical line to the left of the row with color based on the grading criterion.
    let className: string
    switch (criteria.grade) {
        case GradingCriterion_Grade.PASSED:
            className = "passed"
            break
        case GradingCriterion_Grade.FAILED:
            className = "failed"
            break
        case GradingCriterion_Grade.NONE:
            className = "not-graded"
            break
    }

    const passed = criteria.grade === GradingCriterion_Grade.PASSED
    // manageOrShowPassed renders the ManageCriteriaStatus component if the user is a teacher, otherwise it renders a passed/failed icon
    const criteriaStatusOrPassFailIcon = isTeacher
        ? <CriteriaStatus criterion={criteria} />
        : <i className={passed ? "fas fa-check text-success" : "fas fa-circle-exclamation text-error"} />


    let comment: React.JSX.Element | null = null
    let button: React.JSX.Element | null = null
    if (isTeacher) {
        // Display edit icon if comment is empty
        // If comment is not empty, display the comment
        button = <UnstyledButton onClick={() => setEditing(true)}><i className="fas fa-pen-to-square text-base-content/70 hover:text-base-content" aria-hidden="true" /></UnstyledButton>
        if (criteria.comment.length > 0) {
            comment = <CriterionComment comment={criteria.comment} />
        }
    } else {
        comment = <CriterionComment comment={criteria.comment} />
        button = <UnstyledButton onClick={() => setShowComment(!showComment)}><i className={`${!showComment ? "far" : "fas"} fa-comment text-base-content/70 hover:text-base-content`} /></UnstyledButton>
    }

    // Only display the comment if the comment is not empty
    const displayComment = criteria.comment.length > 0
    return (
        <>
            <tr className="align-items-center">
                <td className={`${className} pl-3! criteria-description`}>{criteria.description}</td>
                <td>
                    {criteriaStatusOrPassFailIcon}
                </td>
                <td>
                    { // Only display the comment button if the comment is not empty, or if the user is a teacher
                        (displayComment || isTeacher) ? button : null
                    }
                </td>
            </tr>
            {displayComment ?
                <tr className={`comment comment-${className}${!showComment ? " hidden" : ""} `}>
                    <td onClick={() => setEditing(true)} colSpan={3}>
                        {comment}
                    </td>
                </tr> : null
            }
            <GradeComment grade={criteria} editing={editing} setEditing={setEditing} />
        </>
    )
}

export default Criteria
